import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

export const queryLocaleStrings = {
  async localeStrings(parent, args, context, info) {
    let { drafts } = args
    const { lang = AppSettings.defaultLocale(), cdn = true } = args

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    drafts = drafts ?? false
    const draftsFilter = drafts ? "" : `&& !(_id in path("drafts.**"))`

    let localeStrings
    localeStrings = await client.fetch(
      groq`*[_type=="local_string" ${draftsFilter}]{
        "id": _id,
        "key": string.key,
        "text": string.text
      }`,
    )

    localeStrings = localeStrings || []

    return localeStrings
  },
}
